const setSpouseTitle = (id = null, val = null) => {
  return {
    type: 'SET_SPOUSETITLE',
    id,
    data: val,
  }
}

export default {
  setSpouseTitle,
}